import React, { useEffect, useState, useRef } from 'react'
import PartyForm from './PartyForm';
import partyServices from '../partyServices';
import { useAlert } from '../../../../../../context/AlertContext';
import { useAppData } from '../../../../../../context/AppDataContext';
import { Autocomplete, TextField, createFilterOptions } from '@mui/material';
import { Edit, PublishedWithChanges } from '@mui/icons-material';

const filterOptions = createFilterOptions({
  matchFrom: 'any',
  stringify: (option) => `${option.label} ${option.phone}`,
});


function SelectParty({party,setParty,partyRole,partyId}) {

  const focusInputRef = useRef(null);
  useEffect(() => {
    const timer = setTimeout(() => {
      if (focusInputRef.current) {
        focusInputRef.current.focus();
      }
    }, 100); // Gives the modal animation a brief moment to settle

    return () => clearTimeout(timer);
  }, []);

  const [phoneInput,setPhoneInput] = useState("");
  const {partyDD} = useAppData();
  const {AppAlert} = useAlert();

  const getPartyDetails = (id) =>{
    partyServices.getById(id).then(res=>{
      setParty(res.data)
    }).catch(error=>{
      console.log(error)
    })
  }

  const search = () =>{
    partyServices.searchByPhone(phoneInput).then(res=>{
      if(res.data){
        setParty(res.data);
      } else {
        AppAlert("No record Found","error")
      }
    }).catch(error=>{
      AppAlert("Someting went wrong, Try Again","error")
    })
  }

  const handleKeyUp = (event) => {
    if (event.key === 'Enter' && phoneInput.length === 10) {
      search();
    }
  };

  useEffect(()=>{
    if(partyId){
      getPartyDetails(partyId);
    }
  },[partyId])
  

  return (

    <>
    {
      party ?
        <div className='row'>
            <div className='col-md-12 mb-3'>
                <div className="input-group">
                    <span className="input-group-text">Party Name</span>
                    <input type='text' className='form-control' value={party.displayName} />
                    <button className='btn btn-outline-secondary' onClick={()=>setParty(null)} ><PublishedWithChanges/></button>
                    <PartyForm callBackWithId={getPartyDetails} data={party} />
                </div>
            </div>
        </div>
        :
        <div className='row'>
          <div className='col-md-6'>
            <Autocomplete
                      options={partyDD}
                      filterOptions={filterOptions}
                      getOptionKey={(option) => option.value}
                      onChange={(event, newValue) => {
                          getPartyDetails(newValue.value)
                      }}
                      className='bg-white'
                      
                      renderInput={(params) => <TextField inputRef={focusInputRef}  {...params} size="small" label='Select Party' /> } 
                  />
          </div>
          <div className='col-md-6'>
            <span className="me-3">OR</span>
            <span><PartyForm callBackWithId={getPartyDetails} partyRole={partyRole} /></span>
          </div>
          {/*
          <div className='col-md-12'>
              <div className="input-group mb-3">
                <span className="input-group-text">Customer</span>
                <input 
                  placeholder='Enter phone to search party' type="text" 
                  className="form-control" 
                  value={phoneInput} 
                  onChange={(e)=>setPhoneInput(e.target.value)} 
                  onKeyUp={handleKeyUp}
                />
                <button className="btn btn-primary" type="button" onClick={search} disabled={phoneInput.length !== 10}   >Search</button>
                <span className="input-group-text">OR</span>
                <PartyForm callBackWithId={getPartyDetails} partyRole={partyRole} />
              </div>
          </div>
          */}
        </div>
      }
    </>
  )
}

export default SelectParty